import styled from 'libs/styled';
import useBreakpoint from '@sportson/core-web/hooks/useBreakpoint';

import Row from '@sportson/core-web/App/layouts/Row';
import Grid from '@sportson/core-web/App/layouts/Grid';
import Text from 'components/Text';
import { Check } from 'assets/media/icons/Check';
import Link from 'components/Link';

const Wrapper = styled(Row)`
    width: 100%;
    justify-content: space-between;
    border-top: 1px solid var(--color-neutrals-200);
    border-bottom: 1px solid var(--color-neutrals-200);
    padding: 16px 8px;
`;

export interface UspsProps {
    usps: { usp: string; link: string | null }[];
}

export const Usps = ({ usps }: UspsProps) => {
    const isMobile = useBreakpoint({ to: 'tablet.sm' });

    if (usps.length === 0) {
        return null;
    }

    return isMobile ? (
        <Grid
            columns="2"
            p="16px 0"
            rowGap="8px"
            columnGap="16px"
            borderTop="1px solid var(--color-neutrals-200)"
            borderBottom="1px solid var(--color-neutrals-200)"
        >
            {usps.length > 0 &&
                usps.map(({ usp, link }) => (
                    <Row key={usp} alignItems="center" width="auto">
                        <Check />
                        {link ? <Link to={link}>{usp}</Link> : <Text typography="UI/12_100_0_450">{usp}</Text>}
                    </Row>
                ))}
        </Grid>
    ) : (
        <Wrapper>
            {Array.isArray(usps) &&
                usps.map(({ usp, link }) => (
                    <Row key={usp} alignItems="center" width="auto">
                        <Check />
                        {link ? <Link to={link}>{usp}</Link> : <Text typography="UI/12_100_0_450">{usp}</Text>}
                    </Row>
                ))}
        </Wrapper>
    );
};
